// From svg-baker@1.7.0 `namespaces.js` (MIT, JetBrains), converted from CommonJS to
// an ES module. It is the only thing svg-baker-runtime imported from svg-baker.
const namespaces = {
    svg: {
        name: 'xmlns',
        uri: 'http://www.w3.org/2000/svg',
    },
    xlink: {
        name: 'xmlns:xlink',
        uri: 'http://www.w3.org/1999/xlink',
    },
};
export default namespaces;
